import { getSaleObjectStore, onError, onSuccess } from "./indexedDbCrud.helper"

const putDataInStore = (request, objectStore, payload) => {
  const data = request.result
  data.data = payload
  return objectStore.put(data)
}

const onUpdateSuccess = (request, payload, objectStore, commit) => {
  const updateRequest = putDataInStore(request, objectStore, payload)

  updateRequest.onsuccess = () =>
    onSuccess(commit, "Pedido offline atualizado com sucesso")

  updateRequest.onerror = event =>
    onError(event, "Erro ao atualizar o pedido offline.", commit)
}

export const handleUpdateSuccess = (event, payload, id, commit) => {
  const objectStore = getSaleObjectStore(event, "readwrite", "sales")
  const request = objectStore.get(id)

  request.onsuccess = () =>
    onUpdateSuccess(request, payload, objectStore, commit)
}
